shallowFreeze